const SustainabilitySection = () => (
  <section className="grid__container">
    <div className="grid__row content-block">
      <div className="grid__column--12">
        <h2>Sustainability</h2>
        <p>
          Sustainability matters to both Skyscanner and travellers (65% of whom
          say it&apos;s important to them when they travel). Travel can be a
          force for good, whether that&apos;s learning about other cultures,
          building connections around the world or in visiting friends and
          family.
        </p>
        <p>
          However, transportation, particularly air travel, can cause
          significant environmental impact, contributing heavily to carbon
          emissions. Additionally, the rising demand for popular destinations
          can result in over-tourism, which can place increasing strain on local
          communities and ecosystems. Skyscanner has a responsibility to
          collaborate with our partners, suppliers and travellers to build a
          more sustainable future for travel and tourism.
        </p>
      </div>
    </div>

    <div className="grid__row content-block" style={{ paddingTop: '0' }}>
      <div className="video-container--landscape">
        <video
          className="video"
          controls
          src="https://content.skyscnr.com/m/2b166d40dd7ae385/original/skyscnInternal-Sustainability-v3.mp4"
          width="100%"
          poster="https://content.skyscnr.com/m/1a70f62a84497324/original/sustainability-thumbnail.png?imbypass=true"
        >
          <track
            src="../../transcripts/Skyscanner-Sustainability-v3-en-GB"
            kind="captions"
            label="English"
          />
        </video>
      </div>
    </div>

    <div className="grid__row impact-hotspots-container row--top-align content-block">
      <div className="grid__column--6 grid__column--tablet-12 photo-container">
        <img
          className="photo"
          alt="A Skyscanner user reading their phone while sitting on a bus"
          src="https://content.skyscnr.com/m/3c4f865d0f10f13d/original/sustainability1v2.jpg?imbypass=true"
        />
      </div>

      <div className="grid__column--6 grid__column--tablet-12">
        <p className="no-top-margin">
          We&apos;re working on a number of ways to help drive tourism to
          lesser-known areas, away from &lsquo;hotspots&rsquo;. This includes an
          &lsquo;underrated destination&rsquo; inspiration feature in our
          Everywhere search. By inspiring travellers to look at alternatives to
          big ticket capital cities and popular destinations, we can not only
          help them to support more local communities, but also reduce
          over-tourism.
        </p>
      </div>
    </div>

    <div className="grid__row impact-emissions-container row--top-align content-block">
      <div className="grid__column--6 grid__column--tablet-12 photo-container--left">
        <img
          className="photo mobile-and-tablet-only"
          alt="Skyscanner mobile app showing lower emissions flights"
          src="https://content.skyscnr.com/m/92a5313a1964e60/original/sustainability-phone.png?imbypass=true"
        />
      </div>

      <div className="grid__column--6 grid__column--tablet-12">
        <p className="no-top-margin">
          As well as highlighting lower-than-typical emissions flights in our
          product, we&apos;ve also introduced EV car hire, hotel filters for EV
          charging and are trialling trains in some markets. Travellers can find
          sustainability information in our{' '}
          <a href="https://www.skyscanner.net/media/sustainability">
            sustainability hub.
          </a>
        </p>
        <p>
          We&apos;ve partnered with the regenerative tourism fund,{' '}
          <a href="https://untoursfoundation.org/">UnTours Foundation</a> to
          support changemaking small tourism businesses.
        </p>
      </div>

      <div className="grid__column--6 grid__column--tablet-12 photo-container--right">
        <img
          className="photo desktop-only"
          alt="Skyscanner mobile app showing lower emissions flights"
          src="https://content.skyscnr.com/m/92a5313a1964e60/original/sustainability-phone.png?imbypass=true"
        />
      </div>
    </div>

    <div className="grid__row row--top-align">
      <div className="grid__column--6 grid__column--tablet-12 photo-container photo-container--cropped">
        <img
          className="photo"
          alt="Three employees enjoying some coffee"
          src="https://content.skyscnr.com/m/442df2fee9d9b6de/original/sustainability3v2.jpg?imbypass=true"
        />
      </div>

      <div className="grid__column--6 grid__column--tablet-12">
        <p className="no-top-margin">
          We&apos;ve committed to reaching net zero by 2045, having signed the
          Glasgow Declaration in 2021, measured our footprint under the
          Greenhouse Gas Protocol and published our Climate Action Plan.
        </p>
        <p>
          We&apos;re founding partners of SkyNRG&apos;s{' '}
          <a href="https://www.skyscanner.net/news/company-news/five-years-of-partnership-between-skyscanner-and-skynrg">
            Board Now
          </a>{' '}
          programme, which helps contribute to the development of Sustainable
          Aviation Fuel (and reduce the impact of our own business travel
          emissions through this). We&apos;re a founding partner of Travalyst,
          where we&apos;ve aligned with partners around the Travel Impact Model
          for displaying aviation emissions in our search results, and are
          members of Tech Zero, a tech climate action group.
        </p>
      </div>
    </div>
    <hr aria-hidden="true" />
  </section>
);

export default SustainabilitySection;
